import { ProductCard } from "@/src/components/cards/components/ProductCard";
import { SkeletonProps } from "../../skeletons/types";
import { Skeleton } from "../../skeletons/components/Skeleton";

export function SkeletonProductCard(props: SkeletonProps) {
  return (
    <Skeleton {...props}>
      <ProductCard />
    </Skeleton>
  );
}
